import './App.css';
import Home from './Home';
import Skills from './Skills';
import Knowledge from './Knowledge';
import bank from "./assets/bank.png"
import djangochannels from "./assets/djangochannels.png"
import epcommerce from "./assets/epcommerce.png"
import { AiOutlineFacebook, AiOutlineInstagram,AiOutlineYoutube, AiOutlineMail, AiOutlinePhone} from "react-icons/ai";
import { FiLinkedin, FiGithub} from "react-icons/fi";
import {CiTwitter} from "react-icons/ci";
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css';
import { IoIosStarOutline } from "react-icons/io";
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';




function App() {
  const[state, setState]=useState("all")

  function frontend(){
    setState("frontend")
    
  }
  function backend(){
    setState("backend")

  }
  function all(){
    setState("all")

  }
  const handleCopy = () => {
    return alert("Text copied to clipboard")      
  };



  return (
    <div className="w-full h-fit">
        <div id="home" className="h-fit w-[100%] sm:flex justify-between items-center px-[7%] py-[10px]  xs:pl[7%] fixed bg-gradient-to-r from-[#764ABC] to-black text-white z-99">
          <p className="cursor-pointer mb-5 sm:mb-0">
            <a href="home" className='hidden sm:block'><IoIosStarOutline  style={{color: 'yellow', fontSize: '35px'}}/>  </a>
            <a href="home" className='sm:hidden'> <IoIosStarOutline  style={{color: 'yellow', fontSize: '35px'}}/> </a>
            </p>
          <div className=" flex items-center gap-5 xs:justify-between">
          <a href="#skills"><p className="cursor-pointer">Projects</p> </a>
          <p className="cursor-pointer"><a href="#knowledge"> Skills </a></p>
          <p className="cursor-pointer"><a href="#about"> About </a></p>
          <p className="cursor-pointer xs:hidden"><a href="#contact"> Contact </a></p>
          <div className="w-fit h-fit xs:px-2 rounded-xl px-6 py-2 bg-[#8c14fc] cursor-pointer flex gap-2">
            <a href="mailto:emmanuel47peters@gmail.com">
            Hire Me
            </a>
          </div>
        </div>
      </div>
      <div className="w-full h-fit overflow-hidden">
        <Home />
      </div>

      {/* my portfolio */}
      <div id='skills' className="w-full h-fit py-4">
      <div className="w-full flex justify-center items-center gap-2 mb-7 mt-4">
      <div className="text-4xl sm:text-4xl text-[#0d2438] ">My</div>
      <div className="text-4xl sm:text-4xl text-[#0d2438]  ">Portfolio</div>
      </div>
        <div className="w-full h-fit flex justify-center gap-11">
          <p onClick={all} className={`w-fit h-fit cursor-pointer px-5 py-3 rounded-md ${state==="all" && "bg-[#8c14fc] text-white"} ` }>All</p>
          <p onClick={frontend} className={`w-fit h-fit cursor-pointer px-5 py-3 rounded-md ${state==="frontend" ? "bg-[#8c14fc] text-white":"text-[#0d2438]"} ` }>Frontend</p>
          <p onClick={backend} className={`w-fit h-fit cursor-pointer px-5 py-3 rounded-md ${state==="backend" ? "bg-[#8c14fc] text-white":"text-[#0d2438]"} ` }>Backend</p>
        </div>
       {state==="all" && <div className="w-full h-fit px-[17%] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 my-6 sm:gap-7">
          <a href="https://django-channels-byf5.onrender.com/"> <Skills img={djangochannels} name={"Chatting website"} category={"Web Application"} details={"A real-time chatting website, where people can make friends. Built with django"}/> </a>
          <a href="https://epcommerce.vercel.app/"><Skills img={epcommerce} name={"Shop Ecommerce"} category={"Web Application"} details={"An ecommerce with real-time notification.Built with django and react" }/></a>
          <a href="https://bank-at0v.onrender.com/"><Skills img={bank} name={"Bank webapp"} category={"Web Application"} details={"A real life bank simulation app, for day to ay activities. Built with django"}/></a>
        </div>}
       {state==="frontend" && <div className="w-full h-fit px-[17%] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 my-6 sm:gap-7">
          {/* <Skills img={ui} name={"Shop Ecommerce"} category={"Web Application"} details={"A weather App with the implementation of real life weather API for weather condition of a region"}/>
          <Skills img={ui} name={"Shop Ecommerce"} category={"Web Application"} details={"A weather App with the implementation of real life weather API for weather condition of a region"}/> */}
        </div>}
       {state==="backend" && <div className="w-full h-fit px-[17%] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 my-6 sm:gap-7">
       <a href="https://django-channels-byf5.onrender.com/"> <Skills img={djangochannels} name={"Chatting website"} category={"Web Application"} details={"A real-time chatting website, where people can make friends. Built with django"}/> </a>
          <a href="https://epcommerce.vercel.app/"><Skills img={epcommerce} name={"Shop Ecommerce"} category={"Web Application"} details={"An ecommerce with real-time notification.Built with django and react" }/></a>
          <a href="https://bank-at0v.onrender.com/"><Skills img={bank} name={"Bank webapp"} category={"Web Application"} details={"A real life bank simulation app, for day to ay activities. Built with django"}/></a>
        </div>}
      </div>

      {/* knowledge */}
      <div className='w-full h-fit relative z-[-1]'> 
        <div id='knowledge' className='w-full h-fit'> 
          <Knowledge />
        </div>
        {/* 764ABC */}
        <div className='w-full h-fit flex justify-center'> 
          {/* <div className='w-[300px] h-[300px] bg-gradient-to-br from-[#764ABC] to-black absolute bottom-[-7%] sm:bottom-[-20%] md:top-[92%] rounded-lg text-center pt-3'>  */}
          <div id='about' className='w-[300px] h-fit bg-black absolute bottom-[-10%] xs:bottom-[-7%] sm:bottom-[-13%] md:bottom-[-18%] lg:bottom-[-22%] rounded-lg text-center pt-3'> 
            <div className='text-[#764ABC]'> 
              About Me
            </div> 
          <p className='text-white/70 px-4 mb-4 '> I am a passionate web developer with expertise in React, Django, Python, JavaScript, Tailwind CSS,e.t.c. Am highly skilled at buiding exceptional digital experience through efficient and visually appealing web applications. I take pride in being a dedicated team player who believes in the power of collaboration. With a strong commitment to delivering projects promptly, I strive to exceed expectations and provide exceptional results.</p>
          </div>    
        </div>    
      </div>    

      {/* contact-me */}
      <div id='contact' className='w-full h-fit text-center mt-[350px]'> 
        <div className="text-4xl sm:text-4xl text-[#0d2438] mt-4 ">Contact me</div>
        <div className="text-lg font-semibold text-black/70 mt-2"> Email</div>
        <div className='w-full h-fit flex justify-center  '> 
          <div id="my-tooltip" className='w-fit h-fit flex justify-center gap-2 items-center bg-[#04af7c] px-4 py-2 rounded-sm '> 
            <AiOutlineMail className="text-white"/>
            <div className="text-sm text-white text-center"><a href="mailto:emmanuel47peters@gmail.com">Emmanuel47peters@gmail.com  </a></div>
            <Tooltip anchorSelect="#my-tooltip"  content="Click me"  className='w-[100px] h-fit text-center'/> 
          </div>
        </div>
        <div className="text-lg font-semibold text-black/70 mt-3">Phone Number</div>
        <div className='w-full h-fit flex justify-center cursor-pointer'> 
        <CopyToClipboard text={"09032138727"} onCopy={handleCopy}>
          <div id="my-phone" className='w-fit h-fit flex justify-center gap-2 items-center bg-[#e11584] px-4 py-2 rounded-sm '> 
            <AiOutlinePhone className="text-white"/>
            <div className="text-sm text-white">Emmanuel47peters@gmail.com</div>
            <Tooltip anchorSelect="#my-phone"  content="click to copy"  className='w-[100px] h-fit text-center'/> 
          </div>
          </CopyToClipboard>
        </div>
        <div className="text-4xl sm:text-4xl text-[#0d2438] mt-7 ">Follow me</div>
        <div className="flex justify-center xs:gap-5 gap-7 cursor-pointer mt-2">
          <div id="my-fb" className="p-2 rounded-lg hover:bg-indigo-200">
            <AiOutlineFacebook  className="text-4xl md:text-4xl xl:text-5xl 2xl:text-6xl text-gray-600 hover:scale-110 transition-transform duration-300" style={{ fontSize: '3xl' }}/>
            <Tooltip anchorSelect="#my-fb"  content="Facebook"  className='w-[100px] h-fit text-center'/> 
          </div>
          <div id="my-insta" className="p-2 rounded-lg hover:bg-indigo-200">
            <AiOutlineInstagram className="text-4xl md:text-4xl xl:text-5xl 2xl:text-6xl text-gray-600 hover:scale-110 transition-transform duration-300" style={{ fontSize: '3xl' }} />
            <Tooltip anchorSelect="#my-insta"  content="Instagram"  className='w-[100px] h-fit text-center'/> 
          </div>
          <div id="my-twitte" className="p-2 rounded-lg hover:bg-indigo-200">
            <CiTwitter className="text-4xl md:text-4xl xl:text-5xl 2xl:text-6xl text-gray-600 hover:scale-110 transition-transform duration-300" style={{ fontSize: '3xl' }}/>
            <Tooltip anchorSelect="#my-twitter"  content="Twitter"  className='w-[100px] h-fit text-center'/> 
          </div>
          <div id="my-git" className="p-2 rounded-lg hover:bg-indigo-200">
            <FiGithub className="text-4xl md:text-4xl xl:text-5xl 2xl:text-6xl text-gray-600 hover:scale-110 transition-transform duration-300" style={{ fontSize: '3xl' }}/>
            <Tooltip anchorSelect="#my-git"  content="Github"  className='w-[100px] h-fit text-center'/> 
          </div>
          <div id="my-link" className="p-2 rounded-lg hover:bg-indigo-200">
          <FiLinkedin className="text-4xl md:text-4xl xl:text-5xl 2xl:text-6xl text-gray-600 hover:scale-110 transition-transform duration-300" style={{ fontSize: '3xl' }}/>
          <Tooltip anchorSelect="#my-link"  content="LinkedIn"  className='w-[100px] h-fit text-center'/> 
        </div>
        </div>
        
        <div className="text-4xl sm:text-4xl text-[#0d2438] mt-7 ">Watch my Tutorials on Youtube</div>
        <div className="w-full flex justify-center cursor-pointer">
          <div id="my-tube"  className="w-fit p-2 rounded-lg ">
          <AiOutlineYoutube className="text-4xl md:text-4xl xl:text-5xl 2xl:text-6xl text-gray-600 hover:scale-110 transition-transform duration-300 bg-indigo-200 rounded-lg p-2" style={{ fontSize: '3xl' }}/>
          <Tooltip anchorSelect="#my-tube"  content="Youtube"  className='w-[100px] h-fit text-center'/> 
          </div>
        </div>
      </div>

    </div>
    
  );
}

export default App;
